import React from "react";
import styled from "styled-components";

import theme from "../../styles/theme";

const StyledSvg = styled.svg`
  display: none;
  ${() => theme.media.tabletUp`
    width: 100%;
    display: block;
  `};
`;


const StretchLogoDesktop = () => {
  return (
    <div>
      <StyledSvg width="1200" height="526" viewBox="0 0 1200 526" fill="none">
        <path
          d="M1200 443.619C1200 439.587 1196.73 436.318 1192.7 436.318H1143.93C1139.9 436.318 1136.63 433.049 1136.63 429.017V244.104C1136.63 240.071 1139.9 236.802 1143.93 236.804L1192.7 236.822C1196.73 236.824 1200 233.555 1200 229.521V7.30071C1200 3.26865 1196.73 0 1192.7 0H389.723C386.987 0 384.48 1.52968 383.23 3.96292L280.36 204.078L178.736 3.99461C177.491 1.54388 174.975 0 172.226 0H7.30071C3.26865 0 0 3.26863 0 7.3007V119.847C0 123.879 3.26863 127.147 7.3007 127.147H55.4892C59.5213 127.147 62.7899 130.416 62.7899 134.448V281.453C62.7899 285.485 59.5213 288.754 55.4892 288.754H7.3007C3.26864 288.754 0 292.023 0 296.055V518.699C0 522.731 3.26863 526 7.3007 526H181.6C185.632 526 188.9 522.731 188.9 518.699V398.009C188.9 393.977 185.632 390.708 181.6 390.708H133.58C129.548 390.708 126.279 387.44 126.279 383.408V188.38L237.571 408.745C239.574 412.711 245.218 412.765 247.297 408.839L370.154 176.846V383.408C370.154 387.44 366.885 390.708 362.853 390.708H300.059C296.027 390.708 292.758 393.977 292.758 398.009V518.699C292.758 522.731 296.027 526 300.059 526H1192.7C1196.73 526 1200 522.731 1200 518.699V443.619Z"
          fill="#C8F169"
        />
      </StyledSvg>
    </div>
  );
};

export default StretchLogoDesktop;
